import { Pipe, PipeTransform } from '@angular/core';
import { DbrBalloonEntity } from '@balloon-race-fullstack-monorepo/dbr-rest-api';

@Pipe({
  name: 'balloonStatusKeyPipe',
  standalone: true,
})
export class BalloonStatusKeyPipe implements PipeTransform {
  transform(balloon: DbrBalloonEntity): string {
    if (balloon.finished) {
      switch (balloon.targetBehaviour) {
        case 1:
          return 'balloons.status.exploded';
        case 2:
          return 'balloons.status.crashed';
        case 3:
          return 'balloons.status.landed';
      }
    }
    if (balloon.currentPosition && !balloon.finished) {
      return 'balloons.status.flying';
    } else {
      return '';
    }
  }
}
